import { Flex, Icon, Tooltip } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box
import { Box } from '@aloft/toolkit-sui/chakra';

import { TwoLineCell } from '../../../Grid/TwoLineCell.tsx';
import { CompSelectionProperty } from '../../types.ts';
import { RankPinIcon } from './RankPinIcon.tsx';
import { SubjectPinIcon } from './SubjectPinIcon.tsx';
import { getPinColor } from './getPinColor.ts';

export const AddressColumn = (property: CompSelectionProperty) => {
  const { address, id, similarityRank, reo, shortSale, mlsStatus } = property;
  const { AddressLineText, CityName, StateCode, PostalCode } = address ?? {};

  const warningMessages: string[] = [];
  if (reo) warningMessages.push('This is a REO transaction');
  if (shortSale) warningMessages.push('This is a short sale transaction');

  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%" gap="8px">
      <Flex height="100%" alignItems="center" justifyContent="center" flexShrink={0}>
        {id === 'subject' ? (
          <SubjectPinIcon />
        ) : (
          <RankPinIcon color={getPinColor(mlsStatus)} rank={similarityRank} />
        )}
      </Flex>
      <Box paddingRight={2} flexGrow={1} minWidth={0}>
        <TwoLineCell
          line1={AddressLineText ?? ''}
          line2={`${CityName}, ${StateCode} ${PostalCode}`}
        />
      </Box>
      {(reo || shortSale) && (
        <Flex alignItems="center" gap="4px" flexShrink={0}>
          <Tooltip label={warningMessages.join('\n')} whiteSpace="pre-line">
            <Icon icon="error-warning" size="md" color="statusWarning" />
          </Tooltip>
        </Flex>
      )}
    </Flex>
  );
};
